// extracted by mini-css-extract-plugin
module.exports = {"container":"page-top-panel_container__3wuuU","title":"page-top-panel_title__1GqX4"};